/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import { Breadcrumb, BreadcrumbItem } from 'reactstrap';
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router-dom/cjs/react-router-dom';
import { useSelector } from 'react-redux';

const Crums = () => {
  const location = useLocation();
  const boxDetails = useSelector((state) => state.AppState.boxDetails.box);

  let currentLink = '';
  let boxId = '';

  const crumbs = location.pathname.split('/').filter(crumb => crumb !== '').map((crumb, index, array) => {
    currentLink += `/${crumb}`;
    let crumbLink = currentLink;
    let displayCrumb = crumb.split('-').join(' ');
    if (crumb === 'boxes') {
      displayCrumb = "Edge Devices";
    }
    if (crumb === 'provisioning') {
      crumbLink = '/provisioning/new-number';
    }
    if (crumb === 'porting') {
      crumbLink = '/provisioning/porting';
    }
    if (crumb === 'order' && index < array.length - 1) {
      crumbLink = location.pathname;
    }

    const last = index === array.length - 1;
    return last ? (
      <BreadcrumbItem className={array.length === 2 ? 'pl-2' : 'pl-4'} active key={`${crumbLink}-${index}`}>
        {array.length === 2 && array[0] === 'boxes' ? (boxDetails?.displayName || array[1]) : displayCrumb}
      </BreadcrumbItem>
    ) : (
      <BreadcrumbItem className="pl-4" key={`${crumbLink}-${index}`}>
        <Link to={crumbLink}>{displayCrumb}</Link>
      </BreadcrumbItem>
    );
  });
  return (
    location === '/' ? null :
      <Breadcrumb>
        {crumbs}
      </Breadcrumb>
  );
}

export default Crums;
